import { supabase } from "@/integrations/supabase/client"

export interface VeiculoResumo {
  id: string
  placa: string
  marca: string
  modelo: string
  ano: number
  cor: string | null
  foto_principal: string | null
}

export async function buscarVeiculoPorPlaca(
  placa: string,
  lojaId: string,
): Promise<VeiculoResumo | null> {
  const { data, error } = await supabase
    .from("veiculos")
    .select("id, placa, marca, modelo, ano, cor, foto_principal")
    .eq("loja_id", lojaId)
    .eq("placa", placa.toUpperCase())
    .maybeSingle()

  if (error) throw error
  return data
}
